import type { User } from '@/types'
import type { UsersState } from './state'

export const createGetters = (state: UsersState) => {
  const filteredUsers = (): User[] => {
    let result = [...state.users]

    // Filter by search term
    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (user) =>
          user.displayName.toLowerCase().includes(search) ||
          user.email.toLowerCase().includes(search)
      )
    }

    // Filter by role
    if (state.filters.role) {
      result = result.filter((user) => user.role === state.filters.role)
    }

    // Filter by active status
    if (state.filters.isActive !== null) {
      result = result.filter((user) => user.isActive === state.filters.isActive)
    }

    return result
  }

  const getUserById = (userId: string): User | undefined => {
    return state.users.find((user) => user.id === userId)
  }

  const activeUsers = (): User[] => {
    return state.users.filter((user) => user.isActive)
  }

  const usersByRole = (role: string): User[] => {
    return state.users.filter((user) => user.role === role)
  }

  const admins = (): User[] => {
    return state.users.filter((user) => user.role === 'admin')
  }

  const operators = (): User[] => {
    return state.users.filter((user) => user.role === 'operator')
  }

  const clients = (): User[] => {
    return state.users.filter((user) => user.role === 'client')
  }

  const totalUsers = (): number => {
    return state.users.length
  }

  const totalActiveUsers = (): number => {
    return state.users.filter((user) => user.isActive).length
  }

  return {
    filteredUsers,
    getUserById,
    activeUsers,
    usersByRole,
    admins,
    operators,
    clients,
    totalUsers,
    totalActiveUsers,
  }
}
